import React from "react"
import SelectReasonType from "../../nsi/ReReasonTypes/SelectReasonType"
import GetPotentialRepeatedReOrgAppeals from "./getPotentialRepeatedReOrgAppeals"

const SetAppealRepetition = (props) => {
	return (
		<>
			<SelectReasonType
				form={ props.form }
				isRequired={ props.isRequired }
			/>
			<GetPotentialRepeatedReOrgAppeals { ...props } />
		</>
	)
}

export default SetAppealRepetition
